module.exports = __webpack_public_path__ + "static/media/Client.fc8e699e.svg";